import React, { useMemo, useState } from 'react';
import { ManifestHoverItemDetails } from './ManifestHoverItemDetails';
import { FairDate } from '../../services/Utils/Date';
import { useHistory } from 'react-router-dom';
import { createUseStyles } from 'react-jss';
import { ManifestHoverMenu } from './ManifestHoverMenu';
import { RenderState } from '../State/State';

const useStyles = createUseStyles({
  tbody__tr: {
    position: 'relative',
    '&:nth-child(odd)': {
      backgroundColor: 'var(--background-color)', // Color for odd rows
    },
    '&:nth-child(even)': {
      backgroundColor: 'var(--fifth-color)', // Color for odd rows
    },
    '&:hover': {
      backgroundColor: 'var(--alert-notification-backgroundColor)',
      cursor: 'pointer',
    },
    '& td': {
      // Styles applied to all <td> elements inside .tbody__td
      marginRight: 5,
      padding: 5,
    },
    '& td.td__min': {
      // Additional styling for specific th elements
      width: '1px',
    },
  },
  hoverComponent: {
    position: 'relative',
    top: '10px',
  },
  stateField: {
    fontWeight: 'bold',
  },
  menuComponent: {
    color: 'white',
    position: 'absolute',
    width: '75px',
    backgroundColor: 'WindowFrame',
    border: '5px',
    boxSizing: 'border-box',
    padding: '5px',
    textAlign: 'center',
    lineHeight: '1.2',
    borderRadius: '5px',
    zIndex: 15,
    cursor: 'auto',
  },
});

export const ManifestTableRowFragment = ({ manifest }) => {
  const classes = useStyles();
  const history = useHistory();
  const [isHovering, setIsHovering] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [points, setPoints] = useState({
    x: 0,
    y: 0,
  });

  const hoverComponent = useMemo(() => {
    return <ManifestHoverItemDetails id={manifest.id} />;
  }, [manifest.id]);

  const menuComponent = useMemo(() => {
    return <ManifestHoverMenu id={manifest.id} />;
  }, [manifest.id]);

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };
  const handleLeaveMenu = () => {
    setClicked(false);
  };
  const handleStopClick = (event) => {
    // Stops clicking in the menu from propagating to the tr
    event.stopPropagation();
  };
  const handleRowClick = (manifestId) => {
    history.push('/manifests/' + manifestId);
  };
  const handleContextMenu = (e) => {
    setClicked(true);
    e.preventDefault();
    setPoints({
      x: e.pageX,
      y: e.pageY,
    });
  };

  return (
    <tr
      key={manifest.id}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => {
        handleRowClick(manifest.id);
      }}
      className={classes.tbody__tr}
      onContextMenu={handleContextMenu}
    >
      <td className='td__min'>{FairDate(manifest.date.toDate())}</td>
      <td>
        {manifest.name}
        <span className={classes.hoverComponent}>{isHovering && hoverComponent} </span>
      </td>
      <td>{manifest.project}</td>
      <td>{manifest.reference}</td>
      <td>{manifest.sender.name}</td>
      <td>{manifest.recipient.name}</td>
      <td className='td__min'>
        {
          <span className={classes.stateField}>
            {RenderState(manifest.state, manifest.stateUpdated)}
          </span>
        }
      </td>
      {clicked && (
        <td
          onClick={handleStopClick}
          onMouseLeave={handleLeaveMenu}
          className={classes.menuComponent}
          style={{
            top: 0, //points.y,
            left: points.x - 150,
          }}
        >
          {menuComponent}
        </td>
      )}
    </tr>
  );
};
